import React from 'react';
import { createRoot, hydrateRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import App from './App';
import { preloadInitialRoute } from './routePreload';
import './index.css';

const rootElement = document.getElementById('root');

function renderApp(preloadedRoute) {
  const app = (
    <HelmetProvider>
      <BrowserRouter>
        <App preloadedRoute={preloadedRoute} />
      </BrowserRouter>
    </HelmetProvider>
  );
  // 09.08, audyt przed wdrozeniem: Nginx (try_files ... /index.html) serwuje ZAWSZE ten sam
  // upieczony przez react-snap index.html (tresc "/") dla kazdego URL-a bez wlasnego pliku - wiec
  // #root ma dzieci (hasChildNodes) rowniez dla /app/*, mimo ze to CALKOWICIE inna, nieupieczona
  // trasa (patrz komentarz w App.jsx przy GapMvpPage - swiadomie poza mechanizmem preloadedRoute).
  // hydrateRoot probowal wtedy pogodzic React z tresci landing page'a -> gwarantowany mismatch
  // (blad #418/#423) przy KAZDYM twardym wejsciu na /app/cokolwiek, nie sporadycznie. Hydratacja ma
  // sens wylacznie dla "/" (jedyna faktycznie prerenderowana trasa) - wszystko inne dostaje zwykly
  // czysty render kliencki.
  const isPrerenderedPath = window.location.pathname === '/';
  if (isPrerenderedPath && rootElement.hasChildNodes()) {
    hydrateRoot(rootElement, app);
  } else {
    createRoot(rootElement).render(app);
  }
}

// Zanim React w ogole zacznie renderowac, doladuj (jesli trzeba) kod strony na ktorej user
// faktycznie wyladowal - zeby PIERWSZY render nie przechodzil przez React.lazy()/Suspense
// (ktory zawsze zawiesza sie na pierwszym renderze, niezaleznie od cache) i nie gryzl sie
// z tresci a upieczona przez react-snap. Patrz routePreload.js + App.jsx (preloadedRoute prop).
preloadInitialRoute(window.location.pathname).then(renderApp);
